<div class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="editorToolbar"></ngx-editor-menu>
    <ngx-editor 
        [editor]="editor" 
        [placeholder]="placeholder" 
        [(ngModel)]="htmlContent"
        (ngModelChange)="onContentChange($event)"
        [disabled]="disabled"
        [class.disabled]="disabled"
        >
    </ngx-editor>
</div>